import * as React from 'react';
import { components, Creatable } from 'react-select';
import AsyncPaginate from 'react-select-async-paginate';
import { FontIcon } from '../../../FontIcon';
import { makeSelectTheme } from '../AutocompleteMultiSelectTheme';
import { MultiValueLabel } from './MultiValueLabel';
import { NoOptionsMessage } from './NoOptionsMessage';
import { Option } from './Option';
import { ValueContainer } from './ValueContainer';
import { useMemo } from 'react';
;
const createDropdownIndicator = (iconConfig) => (props) => (React.createElement(components.DropdownIndicator, Object.assign({}, props),
    React.createElement(FontIcon, { className: iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.className, iconName: (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.icon) || 'arrow2-down', size: (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.size) || 14 })));
const createMenu = (testId) => (props) => (React.createElement(components.Menu, Object.assign({}, props),
    React.createElement("div", { "data-testId": `${testId}-menu` }, props.children)));
export const SelectWrapped = (props) => {
    const { classes, countTranslationKey, disabled = false, iconConfig, isAsync = false, isClearable = false, isCreatable = false, isMulti = false, loadOptionsHandler, mapValuesToSelectOptionsHandler, menuPlacement, menuPosition, onChange, options, placeholder, shouldLoadMoreHandler, t, theme, testId, } = props;
    let { cacheUniq } = props;
    const formatCreateLabel = React.useCallback((value) => `${t('common:add')} ${value}`, [t]);
    if (cacheUniq === undefined && options && !isAsync) {
        cacheUniq = options;
    }
    const DropdownIndicator = useMemo(() => createDropdownIndicator(iconConfig), [iconConfig]);
    const Menu = useMemo(() => createMenu(testId), [testId]);
    const component = {
        MultiValueLabel,
        NoOptionsMessage,
        Option,
        ValueContainer,
        Menu,
        DropdownIndicator
    };
    if (iconConfig) {
        component.DropdownIndicator = DropdownIndicator;
    }
    return (React.createElement(AsyncPaginate, Object.assign({ backspaceRemovesValue: false, cacheUniq: cacheUniq, classes: classes, className: classes.field, closeMenuOnSelect: !isMulti, components: component, countTranslationKey: countTranslationKey, debounceTimeout: isAsync ? 300 : 0, defaultMenuIsOpen: true, formatCreateLabel: formatCreateLabel, hideSelectedOptions: false, isClearable: isClearable, isDisabled: disabled, isMulti: isMulti, loadOptions: loadOptionsHandler, menuPlacement: menuPlacement, menuPosition: menuPosition, onChange: onChange, options: options, placeholder: placeholder, shouldLoadMore: shouldLoadMoreHandler, styles: makeSelectTheme(theme), t: t, value: mapValuesToSelectOptionsHandler(props.value) }, (isCreatable ? { SelectComponent: Creatable } : {}))));
};
//# sourceMappingURL=SelectWrapped.js.map